// @flow

function pluralizeLabel(singularLabel: string, pluralLabel: string, value: number): string {
  return value > 1 ? pluralLabel : singularLabel;
}

function prefixWithPlusIfPositive(value: number, label: string): string {
  return value >= 0 ? `+${label}` : label;
}

function capitalizeName(text?: string): string {
  return (text || '').toLowerCase().replace(/(?:^|[-\s.'&])\S/g, a => a.toUpperCase());
}

export { pluralizeLabel, prefixWithPlusIfPositive, capitalizeName };
